import { hashString } from '../../Helpers/hashString';
import { auth } from '../firebase';

export const getSignedInPersonId: () => string = () => {
    return hashString(auth.currentUser?.email!);
};
